import { Plugin, EditorState, PluginKey} from "prosemirror-state";
import { EditorView } from "prosemirror-view";

// Define the type for the toolbar update function
export type UpdateToolbarCallback = (state: EditorState) => void;

export function createSelectionListenerPlugin(updateToolbar: UpdateToolbarCallback): Plugin {
	return new Plugin({
		key: new PluginKey("selectionListener"),
		view(editorView: EditorView) {
			return {
				update(view: EditorView, prevState: EditorState) {
					const { state } = view;

					// Check if the selection has changed
					if (!prevState.selection.eq(state.selection)) {
						// Call the toolbar update function with the new state
						updateToolbar(state);
					}
				},
			};
		},
	});
}
